import React from 'react'
import Link from 'next/link'
import styles from './styles.module.css'
import { useIntl } from 'react-intl'
import { useRouter } from 'next/router'
import ChevronLeft from 'client/icons/ChevronLeft'
import { useProperty } from 'src/hooks/useProperty'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'
import { usePage } from 'src/hooks/usePage'
import noop from 'lodash/noop'

interface IBackToResultsProps {
  propertyId: number
  country: string
  slug: string
  type: string
  className?: string
}

const BackToResults = ({
  propertyId,
  country,
  slug,
  type,
  className = '',
}: IBackToResultsProps) => {
  const intl = useIntl()
  const { city: destination } = useProperty()
  const { pageId } = usePage()

  // eslint-disable-next-line camelcase
  const {
    query: { aid, total, subtotal, taxes, offer_type: offerType, source },
  } = useRouter()

  const { sendEvent } = useKafkaEvent({ page: pageId, eventName: 'back_to_results' })

  const handleClick = () => {
    sendEvent({ section: SECTIONS.HEADER })
  }

  return (
    <div className={`${styles.backToResults} ${className}`}>
      <Link
        href={{
          pathname: `/${country}/${type ?? 'city'}/${slug}`,
          query: {
            ...(propertyId && { highlightedProperty: propertyId }),
            ...(aid && {
              aid,
              total,
              subtotal,
              taxes,
              offer_type: offerType,
              internal_navigation: true,
              source,
            }),
          },
        }}
        role="link"
        data-track-evt="detail_back_click"
        data-testid="backToResults"
        onClick={handleClick}
        tabIndex={0}
        onKeyDown={noop}
      >
        <ChevronLeft size={16} />
        {intl.formatMessage({ id: 'global.see-all-accommodation2' }, { destination })}
      </Link>
    </div>
  )
}

export default BackToResults
